import PhoneIcon from '@mui/icons-material/Phone';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ConstructionIcon from '@mui/icons-material/Construction';
import DescriptionIcon from '@mui/icons-material/Description';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AddCardIcon from '@mui/icons-material/AddCard';
import HistoryIcon from '@mui/icons-material/History';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PaymentsIcon from '@mui/icons-material/Payments';

// Lista base de tipos de atividade selecionáveis no formulário "+ Adicionar
// Atividade" — mesmo rascunho validado no handoff. Se um dia existir um
// model TipoAtividade cadastrável (mesmo padrão de MotivoAgenda em
// Agenda.js), o ModalAtividade.js tenta buscar de lá primeiro e só cai
// nessa lista fixa se a coleção ainda não existir/estiver vazia.
export const TIPOS_ATIVIDADE_SELECIONAVEIS = [
  'Tentativa de ligação',
  'Envio de mensagem',
  'Atualização de negociação',
  'Informações gerais',
  'Protocolo em distribuidora',
  'Informação de montagem',
  'Nota de projeto',
  'Informação de débitos pendentes',
  'Local fechado',
];

// 'Agenda', 'Desconto', 'Tipo de Contratante' e 'Forma de Pagamento' não
// aparecem no formulário acima (são gerados automaticamente em pontos
// específicos do fluxo, cada um com seu próprio gatilho), mas precisam de
// ícone aqui pra aparecerem certo na lista de Atividades quando registrados.
export const ICONE_POR_TIPO = {
  'Tentativa de ligação': PhoneIcon,
  'Envio de mensagem': ChatBubbleOutlineIcon,
  'Atualização de negociação': SyncAltIcon,
  'Informações gerais': InfoOutlinedIcon,
  'Protocolo em distribuidora': ReceiptLongIcon,
  'Informação de montagem': ConstructionIcon,
  'Nota de projeto': DescriptionIcon,
  'Informação de débitos pendentes': MoneyOffIcon,
  'Local fechado': MeetingRoomIcon,
  Agenda: CalendarMonthIcon,
  Desconto: AddCardIcon,
  'Tipo de Contratante': PersonSearchIcon,
  'Forma de Pagamento': PaymentsIcon,
};

// Fallback: usado tanto para atividades antigas (sem `tipo`, só `msg` —
// textos automáticos do sistema, tipo "Adicionado PIX...") quanto para
// tipos que não estejam no mapa acima.
export const ICONE_PADRAO = HistoryIcon;